import { isPlatformBrowser } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, PLATFORM_ID } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { META_REDUCERS, MetaReducer, StoreModule } from '@ngrx/store';

import { AuthModule } from '@shared/auth';
import { ErrorTracking, PerformanceTracking } from '@shared/tracking';

import { TypedAction } from './actions';
import { ApiHttp } from './api-http.service';
import { BackendModule } from './backend';
import { Datastore } from './datastore';
import { DATASTORE_CONFIG } from './datastore.config';
import { DatastoreConfig } from './datastore.interface';
import { errorHandlerReducerFactory } from './error-handler.reducer';
import { RequestDataEffect } from './request-data.effect';
import { SearchManager, SearchModule } from './search';
import { sessionStorageSyncFactory } from './session-storage-sync.reducer';
import { storeFreezeReducerFactory } from './store-freeze.reducer';
import { WebSocketService } from './websocket';

export function getMetaReducers(
  errorTracking: ErrorTracking,
  performanceTracking: PerformanceTracking,
  config: DatastoreConfig,
  platformId: Object,
): MetaReducer<any, TypedAction>[] {
  const metaReducers: MetaReducer<any, TypedAction>[] = [
    errorHandlerReducerFactory(errorTracking),
  ];
  // Store session cache is disabled in local dev
  if (
    isPlatformBrowser(platformId) &&
    window.location.hostname !== 'localhost'
  ) {
    metaReducers.push(sessionStorageSyncFactory(performanceTracking));
  }
  if (config.enableStoreFreeze) {
    metaReducers.push(storeFreezeReducerFactory(performanceTracking));
  }
  return metaReducers;
}

@NgModule({
  imports: [
    HttpClientModule,
    AuthModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    EffectsModule.forFeature([RequestDataEffect]),
    SearchModule.forRoot(),
    BackendModule.forRoot(),
  ],
  providers: [ApiHttp, WebSocketService],
})
export class DatastoreModule {
  static initialize(config: DatastoreConfig): ModuleWithProviders {
    return {
      ngModule: DatastoreModule,
      providers: [
        Datastore,
        { provide: DATASTORE_CONFIG, useValue: config },
        {
          provide: META_REDUCERS,
          deps: [
            ErrorTracking,
            PerformanceTracking,
            DATASTORE_CONFIG,
            PLATFORM_ID,
          ],
          useFactory: getMetaReducers,
        },
        SearchManager,
      ],
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/core/datastore.module.ts